
<script>
  import Carousel from 'scripts/components/basic/Carousel.vue';
  import Slide from 'scripts/components/basic/Slide.vue';
  import SubscriptionStep from 'scripts/components/basic/SubscriptionStep.vue';

  export default {
    name: 'SizeQuantity',
    components: { Carousel, Slide, SubscriptionStep },
    inject: ['chooseSize'],
    template: '#step4',
    props: [
      'currentStep',
      'step1',
      'step2',
      'step3',
      'step4',
    ],
  };

</script>